module.exports = __webpack_public_path__ + "img/green.0fbfb773.jpg";